import { isEmbedded as detectEmbedded } from '@/utils/embed';
import { useReplaceTargetValidationId } from '@/stores/embedStore';

export type EmbedMode = 'standalone' | 'create' | 'replace';

export const useEmbedMode = (): EmbedMode => {
  const replaceTargetId = useReplaceTargetValidationId();
  if (!detectEmbedded()) return 'standalone';
  return replaceTargetId ? 'replace' : 'create';
};

export const useIsEmbedded = (): boolean => useEmbedMode() !== 'standalone';
